"use strict";
// Main export file for shared types
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_TYPES_VERSION = void 0;
// Export all Firebase types
__exportStar(require("./firebase"), exports);
// Export all Auth types
__exportStar(require("./auth"), exports);
// Export all API types
__exportStar(require("./api"), exports);
// Export all OAuth types
__exportStar(require("./oauth"), exports);
// Version for tracking compatibility
exports.SHARED_TYPES_VERSION = '1.1.0';
